import "./App.css";
import { Provider } from "react-redux";
import { store } from "store";
import { useLayoutEffect } from "react";
import { setThemeVariables } from "constants/theme";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "HomePage";
import DetailPageContainer from "DetailPageContainer";
import { AnalyticsProvider } from "components/analytics/analyticsProvider";
import AdminLogin from "components/admin";

function App() {
  useLayoutEffect(() => {
    setThemeVariables();
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <AnalyticsProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/article/:customPath" element={<DetailPageContainer />} />
            <Route path="/:customPath" element={<DetailPageContainer />} />
          </Routes>
        </AnalyticsProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
